module.exports = __webpack_public_path__ + "static/media/avatarStill.7cfb3d97.gif";